import Request from '../../../../../src/core/gd/data/request'

export default class ApiTrash {

    get(params={}) {
        return new Request(this, 'GET', 'trash', params)
    }


    restore(deletedItemId:ID) {
        return new Request(this, 'POST', 'trash/restore', {
            id: deletedItemId
        })
    }

    static empty() {
        return new Request(this, 'POST', 'trash/empty')
    }

    static hardDeleteOne(deletedItemId:ID) {
        return new Request(this, 'POST', 'trash/delete', {
            id: deletedItemId
        })
    }



}
